const NavigationEmail = () => {
  return <p className="myemail-txt">&lt;  sabahatkanwal007@gmail.com &gt;</p>;
};

export default NavigationEmail;
